export default httpClient => ({

    //--SISTEMA-------------------------------------
    save: async ({ noticia, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/noticias', noticia, { headers });
        return {
            data: response.data
        }
    },
    update: async ({ token, noticia }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.put('/noticias/' + noticia.id, noticia, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/noticias/' + id, { headers });
        return {
            data: response.data
        }
    },

    getAll: async ({ token }) => {
        const headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.get('/noticias', { headers });
        return { data: response.data }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/noticias/' + id, { headers });
        return {
            data: response
        }
    },
    salvarImagem: async ({ token, formImagem }) => {
        let headers = { "Authorization": "Bearer " + token, "Content-Type": "multipart/form-data" }
        const response = httpClient.post('/imagens', formImagem, { headers })
        return {
            data: response.data,
        }
    },
    deletarImagens: async ({ token, imagens }) => {
        const headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.post('/excluir-imagens',
            {
                imagens
            }, { headers })
        return { data: response }
    },
    //---------------------------------------------------


    //-----SITE------------------------------------------
    noticiaPrincipal: async () => {
        const response = await httpClient.get('/noticias-destaque1');
        return { data: response.data }
    },
    noticiaDois: async () => {
        const response = await httpClient.get('/noticias-destaque2');
        return { data: response.data }
    },
    noticaPorCategoria: async () => {
        const response = await httpClient.get('/noticias-por-categoria/54');
        return { data: response.data }
    },
    noticaPorCategoriaAgro: async () => {
        const response = await httpClient.get('/noticias-por-categoria/53');
        return { data: response.data }
    },
    noticiaNome: async ({ titulo_url }) => {
        const response = await httpClient.get('/noticia/' + titulo_url);
        return {
            data: response.data
        }
    },
    videoPrincipal: async () => {
        const response = await httpClient.get('/videos-destaque1');
        return {
            data: response.data
        }
    },
    videoDois: async () => {
        const response = await httpClient.get('/videos-destaque2');
        return {
            data: response.data
        }
    },
    videos: async () => {
        const response = await httpClient.get('/videos');
        return {
            data: response.data
        }
    },
    videoSite: async ({ titulo_url }) => {
        const response = await httpClient.get('/video/' + titulo_url);
        return {
            data: response.data
        }
    },
    buscaNoticia: async ({busca}) => {
        const response = await httpClient.get('/noticias/pesquisa/' + busca);
        return { data: response.data }
    },
});